import React from 'react';
import PropTypes from 'prop-types';
import styles from './GiftingSeasonalPromoBrandRefresh.module.css';
import { GIFTING_SEASONAL_PROMO_DEFAULT } from './giftingSeasonalPromoConstants';

const promoMedia = require('./imgs/promo-photo-overlay.png');
const backToSchoolSticker = require('./imgs/back-to-school-sticker.svg');

function GiftingSeasonalPromoBrandRefresh({
  headlineLineOne,
  headlineLineTwo,
  headlineAccent,
  body,
  ctaText,
  ctaLink,
  ctaButtonType,
  stickerAlt,
  contentSection,
  onCtaClick,
  photoSrc,
  stickerSrc,
}) {
  const handleCtaClick = () => {
    if (onCtaClick && ctaLink) {
      onCtaClick(ctaLink, ctaButtonType, ctaText, contentSection);
    }
  };

  return (
    <section
      className={styles.section}
      data-region="gifting-seasonal-promo"
      aria-labelledby="gifting-seasonal-promo-heading"
    >
      <div className={styles.mediaColumn} data-part="promo-media">
        <div className={styles.mediaFlip} aria-hidden="true">
          <img
            src={photoSrc || promoMedia}
            alt=""
            className={styles.mediaPhoto}
          />
        </div>
        <div className={styles.mediaGradient} aria-hidden="true" />
      </div>

      <div className={styles.copyColumn} data-part="promo-copy">
        <div className={styles.copyBlock} data-part="promo-copy-block">
          <div className={styles.headlineGroup} id="gifting-seasonal-promo-heading">
            <div className={styles.headlinePrimary} data-part="promo-headline-primary">
              <p className={styles.headlinePrimaryLine}>
                {headlineLineOne}
                <br />
                {headlineLineTwo}
              </p>
            </div>
            <p className={styles.headlineAccent} data-part="promo-headline-accent">
              {headlineAccent}
            </p>
          </div>
          <p className={styles.body} data-part="promo-body">
            {body}
          </p>
        </div>
        <button
          type="button"
          className={styles.cta}
          data-part="promo-cta"
          onClick={handleCtaClick}
        >
          {ctaText}
        </button>
      </div>

      <div className={styles.stickerWrap} data-part="promo-sticker">
        <img
          src={stickerSrc || backToSchoolSticker}
          alt={stickerAlt}
          className={styles.stickerArt}
        />
      </div>
    </section>
  );
}

GiftingSeasonalPromoBrandRefresh.propTypes = {
  headlineLineOne: PropTypes.string,
  headlineLineTwo: PropTypes.string,
  headlineAccent: PropTypes.string,
  body: PropTypes.string,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  ctaButtonType: PropTypes.string,
  stickerAlt: PropTypes.string,
  contentSection: PropTypes.string,
  onCtaClick: PropTypes.func,
  photoSrc: PropTypes.string,
  stickerSrc: PropTypes.string,
};

GiftingSeasonalPromoBrandRefresh.defaultProps = {
  ...GIFTING_SEASONAL_PROMO_DEFAULT,
  onCtaClick: null,
  photoSrc: null,
  stickerSrc: null,
};

export default GiftingSeasonalPromoBrandRefresh;
